import { useEffect, useRef } from "react";
import "./AboutusStyles.css"
import IMG_02 from '../Assets/IMG-47.jpg';
import IMG_03 from '../Assets/IMG-42.jpg'
import IMG_04 from '../Assets/IMG-43.jpg'


function AboutUs() {
    const cardsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            {
                threshold:0.2,
            }
        );

        //observe each card
        cardsRef.current.forEach((card) => {
            if (card) {
                observer.observe(card);
            }
        });

        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, []);
    return(
<>

<div className="about-container">
           <div className="f-content">
                    <div className="founder">
                        <h1>Committed to Protecting Your Future</h1>
                        <p>
                                "At Multishade Insurance, we believe in providing peace of mind to our clients through 
                                comprehensive insurance solutions tailored to their unique needs. With years of experience and a 
                                commitment to customer satisfaction, we are dedicated to helping you safeguard your family, property, 
                                and business.,
                        </p>
                    </div>
           </div>
           
            <br></br>
            <br></br>
            <div className="card" ref={(el) => (cardsRef.current[0] = el)}>  
            <h1>
                Our History
                 </h1>
                 <div className="card-flex">
                <div className="card-image right">
                    <img src={IMG_02} alt="Our History"/>
                </div>
               
                <p>
                Founded in 2022, Multishade Insurance has grown from a small local agency into a trusted
                 leader in the insurance industry. Our journey began with a simple mission: to offer reliable
                  and transparent insurance solutions tailored to the unique needs of our clients. Over the years
                  , we have built a reputation for excellence through our commitment to ethical business practices,
                   personalized customer service, and innovative solutions. From protecting families to empowering
                    businesses, we take pride in being a dependable partner during life’s uncertainties. 
                    Our history is a testament to resilience, trust, and a relentless dedication to safeguarding 
                    what matters most</p>
                </div>
            </div>
            
            <div className="card" ref={(el) => (cardsRef.current[1] = el)}>
            <h1>
                Our Vision
                </h1>
                <div className="card-flex">
            <div className="card-image left">
                    <img src={IMG_03} alt="Our Vision"/>
                </div>
                
                <p>
                <b><i>"Empowering Lives, Securing Futures." </i></b>  Our vision is to redefine the insurance landscape
                 by being a beacon of trust and innovation. We aim to empower individuals and businesses to thrive
                  in an uncertain world by providing unparalleled protection, tailored solutions, and proactive 
                  guidance. Through cutting-edge technology and a commitment to sustainability, we envision 
                  a future where everyone feels secure and supported, enabling them to focus on what truly 
                  matters—building their dreams and legacies.
                </p>
                </div>
            </div>
            <div className="card" ref={(el) => (cardsRef.current[2] = el)}>
            <h1>
                     Our Mission
                </h1>
                <div className="card-flex">
                <div className="card-image right">
                    <img src={IMG_04} alt="Our History"/>
                </div>
                
                <p>
                <b><i>"Protection Through Partnership." </i></b>  Our mission is to deliver personalized
                 and accessible insurance solutions that safeguard our clients' aspirations. By fostering 
                 meaningful relationships, leveraging advanced analytics, and prioritizing transparency, we 
                 strive to create a partnership built on trust and reliability. Whether it’s protecting families,
                  businesses, or communities, we are dedicated to providing peace of mind through comprehensive
                   coverage that evolves with our clients' ever-changing needs.
                </p>
                </div>
            
                </div>
            
            </div>

</>
        
    )
    
}

export default AboutUs;